<script setup lang="ts">
    const props = defineProps({
        model: {
            required: true,
        },
        modalStyle: {
            type: String,
            default: 'centered',
        },
    });
    const modal = ref(null);
</script>

<template>
    <Modal
        ref="modal"
        :name="`${model.prefix}:modal`"
        :modal-style="modalStyle"
    >
        <slot></slot>
        <template
            v-if="$slots.navigation"
            #navigation
        >
            <slot name="navigation" />
        </template>
    </Modal>
</template>
